import type { ContentGroupVariantConfig, ContentGroupVariantId } from './content-group.types'

export const contentGroupVariants: Record<ContentGroupVariantId, ContentGroupVariantConfig> = {
  registrationDesktop: {
    surface: 'solid-white',
    padding: 'lg-compact',
    radius: 'xl',
    gap: '23',
    align: 'center',
    justify: 'start',
    border: 'none',
    blur: 'none',
  },
  registrationMobile: {
    surface: 'solid-surface',
    padding: 'mobile-sheet',
    radius: 'xl-top',
    gap: 'none',
    align: 'center',
    justify: 'between',
    border: 'none',
    blur: 'none',
  },
  registrationMobileB2B: {
    surface: 'solid-white',
    padding: 'md-compact',
    radius: 'xl',
    gap: '24',
    align: 'center',
    justify: 'start',
    border: 'none',
    blur: 'none',
  },
  planSelectorDesktop: {
    surface: 'solid-surface',
    padding: 'md-wide',
    radius: 'lg',
    gap: 'none',
    align: 'start',
    justify: 'start',
    border: 'none',
    blur: 'none',
  },
  planSelectorMobile: {
    surface: 'glass-70',
    padding: 'mobile-sheet',
    radius: 'xl',
    gap: '16',
    align: 'start',
    justify: 'start',
    border: 'none',
    blur: 'none',
  },
  planSelectorMobileCatalog: {
    surface: 'transparent',
    padding: 'mobile-sheet',
    radius: 'xl',
    gap: '16',
    align: 'start',
    justify: 'start',
    border: 'none',
    blur: 'none',
  },
  contentDesktop: {
    surface: 'glass-90',
    padding: 'sm',
    radius: 'lg',
    gap: 'none',
    align: 'start',
    justify: 'between',
    border: 'none',
    blur: 'soft',
  },
  contentMobile: {
    surface: 'glass-90',
    padding: 'sm-compact',
    radius: 'lg',
    gap: 'none',
    align: 'start',
    justify: 'between',
    border: 'none',
    blur: 'soft',
  },
  contentMobileCatalog: {
    surface: 'catalog-subscription-panel',
    padding: 'sm-compact',
    radius: 'lg',
    gap: 'none',
    align: 'start',
    justify: 'between',
    border: 'catalog-subscription-panel',
    blur: 'none',
  },
  transparentPanel: {
    surface: 'glass-50',
    padding: 'panel',
    radius: 'lg',
    gap: 'none',
    align: 'start',
    justify: 'between',
    border: 'glass',
    blur: 'none',
  },
  transparentPanelMobile: {
    surface: 'glass-50',
    padding: 'md',
    radius: 'lg',
    gap: '24',
    align: 'start',
    justify: 'start',
    border: 'glass',
    blur: 'none',
  },
  transparentPanelMobileCatalog: {
    surface: 'catalog-subscription-panel',
    padding: 'md',
    radius: 'lg',
    gap: '24',
    align: 'start',
    justify: 'start',
    border: 'catalog-subscription-panel',
    blur: 'none',
  },
  infoPanelMobile: {
    surface: 'info-soft',
    padding: 'sm',
    radius: 'lg',
    gap: '16',
    align: 'start',
    justify: 'start',
    border: 'info',
    blur: 'soft',
  },
  borderBackgroundPanel: {
    surface: 'glass-50',
    padding: 'sm',
    radius: 'lg',
    gap: '12',
    align: 'center',
    justify: 'end',
    border: 'white',
    blur: 'none',
  },
}
